import { render } from "./searchByName.vue?vue&type=template&id=0af15f46"
import script from "./searchByName.vue?vue&type=script&lang=js"
export * from "./searchByName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__